import {CurrentOddsModuleFetchHandler} from "./current-odds-module.fetch-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {CurrentOddsModuleChangeOddsHandler} from "./current-odds-module.change-odds.handler";
import {CurrentOddsModuleToggleOddsMenuHandler} from "./current-odds-module.toggle-odds-menu.handler";
import {ChangeOddsHandler} from "../../../../../core/handlers/change-odds.handler";
import {FullGamePopulateDataHandler} from "../../../../../core/handlers/full-game.populate-data.handler";

export class CurrentOddsModuleHandlers extends HandlerList {

  static injectables = [
    CurrentOddsModuleFetchHandler,
    CurrentOddsModuleChangeOddsHandler,
    CurrentOddsModuleToggleOddsMenuHandler,
    ChangeOddsHandler,
    TimingHandler,
    FullGamePopulateDataHandler
  ];

  constructor(
    currentOddsModuleFetchHandler: CurrentOddsModuleFetchHandler,
    currentOddsModuleChangeOddsHandler: CurrentOddsModuleChangeOddsHandler,
    currentOddsModuleToggleOddsMenuHandler: CurrentOddsModuleToggleOddsMenuHandler,
    changeOddsHandler: ChangeOddsHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler
    ) {
    super();

    [
      currentOddsModuleFetchHandler,
      currentOddsModuleChangeOddsHandler,
      currentOddsModuleToggleOddsMenuHandler,
      changeOddsHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler))
  }
}
